<template>
  <div class="body">
    <img class="bodyBgc" :src="mediaBgc" alt="背景图" />
    <div class="wrap">
      <p class="wrapTitle">合作媒体</p>
      <p class="wrapDesc">PARTNER MEDIAS</p>
      <ul class="wrapNav">
        <li class="wrapNavList" v-for="(item, index) in mediaList" :key="index">
          <img :src="item" alt="媒体" />
        </li>
      </ul>
      <div class="wrapMore" @click="toMore()">查看更多<right-outlined /></div>
    </div>
  </div>
</template>

<script setup>
import { RightOutlined } from '@ant-design/icons-vue'
import { getMedia } from '@/api/2023/index.js'
import { onBeforeMount, ref } from 'vue'
const mediaList = ref([])
const mediaBgc = ref('')
onBeforeMount(async () => {
  await fetch()
})
function fetch() {
  getMedia()
    .then((res) => {
      const data = res.data.data.media
      mediaBgc.value = data.background
      mediaList.value = data.list
    })
    .catch(() => {})
}
function toMore() {
  window.open('https://isc.360.com/2022/logo1.html')
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  width: 100%;
  min-width: 1280px;
  height: 1031px;
  padding-top: 103px;
  &Bgc {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.wrap {
  width: 1280px;
  text-align: center;
  margin: auto;
  &More {
    cursor: pointer;
    width: 160px;
    height: 52px;
    border-radius: 2px;
    background: #00ab7a;
    color: #fff;
    font-size: 20px;
    line-height: 52px;
    text-align: center;
    margin: 60px auto 106px;
  }
  &Title {
    font-size: 40px;
    font-weight: bold;
    line-height: 32px;
    color: #3d3d3d;
    margin: 0;
  }
  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: #3d3d3d;
    margin: 14px 0 65px;
  }
  &Nav {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    width: 100%;
    height: 568px;
    margin: 0;
    &List {
      list-style: none;
      width: 135px;
      height: 56px;
      line-height: 56px;
      background-color: #fff;
      img {
        width: 90px;
        height: 36px;
      }
    }
  }
}
</style>
